import { createFileRoute } from '@tanstack/react-router'
import { ResetPasswordForm } from '@/features/auth/reset-password'

/**
 * Route shell. Definition and guards only — the form lives in a feature.
 *
 * The form reads `token` and `email` from the URL search params (built
 * by the API's `password.reset` named route in `apps/api/routes/web.php`).
 * Both are typed as optional in the search shape so the form can render
 * even if the user arrives without them — a missing token surfaces as a
 * 422 on submit rather than a blank screen.
 */
export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordForm,
  validateSearch: (search: Record<string, unknown>): { token?: string; email?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
})
